// extracted by css-extract-rspack-plugin
export default {"editor":"XcZAf","editorContent":"RWppw","editorContentInner":"gh95A","img":"DUlg0"};